module.exports = __webpack_public_path__ + "static/karolina-7f5d5836680f48b44b8f4745d294eec0.jpg";